/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { useSelector } from 'react-redux';
import { View } from 'react-native';
import { isNative } from '@global/screens';
import TodoListUser from '@/screens/sales-activity/components/todo-list/TodoListUser';
import TodoListVisit from '@/screens/sales-activity/components/todo-list/TodoListVisit';
import TodoListInvoice from '@/screens/sales-activity/components/todo-list/TodoListInvoice';
import TodoListEngage from '@/screens/sales-activity/components/todo-list/TodoListEngage';
import TodoListEvent from '@/screens/sales-activity/components/todo-list/TodoListEvent';

const TodoList = ({
  route = null,
  navigation = null,
  detailData = {},
  detailTodos = [],
  detailCustomer = {},
  hasNoInvoice = false,
  onSubmit,
  onCloseDetail = () => {},
  customerAddress = {},
}) => {
  const userId = useSelector((state) => state.auth.userId);
  const activityType = detailData.activity_type || 'visiting_existing_customer';

  const onSubmitTodoList = () => {
    onSubmit();
  };

  const renderTodoListUser = () => (
    <TodoListUser
      route={route}
      navigation={navigation}
      detailData={detailData}
      detailTodos={detailTodos}
      detailCustomer={detailCustomer}
      hasNoInvoice={hasNoInvoice}
      onSubmit={onSubmitTodoList}
      onCloseDetail={onCloseDetail}
      customerAddress={customerAddress}
    />
  );

  const renderTodoListVisit = () => (
    <TodoListVisit
      route={route}
      navigation={navigation}
      detailData={detailData}
      detailTodos={detailTodos}
      onCloseDetail={onCloseDetail}
    />
  );

  const renderTodoListInvoice = () => (
    <TodoListInvoice detailTodos={detailTodos} />
  );

  const renderTodoListEngage = () => (
    <TodoListEngage detailTodos={detailTodos} />
  );

  const isTodoListUserVisible =
    isNative &&
    detailData?.user?.id === userId &&
    ['approved', 'in_progress'].includes(detailData.status);

  const isTodoListVisitVisible = activityType === 'visiting_existing_customer';
  const isTodoListInvoiceVisible = activityType === 'invoice_collection';
  const isTodoListEngageVisible = activityType === 'engage_potential_customers';

  const isTodoListEventVisible = activityType === 'event_activity';

  const renderTodoListEvent = () => (
    <TodoListEvent detailData={detailData} detailTodos={detailTodos} />
  );

  return (
    <View style={{ width: '100%' }}>
      {(() => {
        switch (true) {
          case isTodoListUserVisible:
            return renderTodoListUser();
          case isTodoListVisitVisible:
            return renderTodoListVisit();
          case isTodoListInvoiceVisible:
            return renderTodoListInvoice();
          case isTodoListEngageVisible:
            return renderTodoListEngage();
          case isTodoListEventVisible:
            return renderTodoListEvent();
          default:
            return false;
        }
      })()}
    </View>
  );
};

export default React.memo(TodoList, (prev, next) => prev == next);
